import script from "./how-indexation-helps-save-taxes-on-capital-gains-from-mutual-funds.vue?vue&type=script&setup=true&lang=js"
export * from "./how-indexation-helps-save-taxes-on-capital-gains-from-mutual-funds.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__